import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "ui-visually-hidden",
  template: `<ng-content></ng-content>`,
  styleUrls: ["./visually-hidden.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisuallyHiddenComponent {}
